import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';

export function usePermissionNameLabel() {
  const { t } = useTranslate();

  return useMemo(() => {
    const permissionNameLabel: Record<General.PermissionName, string> = {
      基础聊天权限: t('department.基础聊天权限'),
      管理员视角: t('department.监督全部'),
      订单敏感信息: t('department.查看买家敏感信息'),
      编辑优惠券: t('department.新建/编辑/作废优惠券'),
      弃单处理页面: t('department.访问订单聚合页'),
      操作弃单: t('department.售后处置权'),
      访问评价聚合页: t('department.访问评价聚合页'),
      履约数据: t('department.查看履约数据'),
      履约数据导出: t('department.导出履约数据'),
      '绩效报告-查看个人绩效': t('department.查看当前帐号绩效'),
      '绩效报告-查看部门绩效': t('department.查看部门下所有帐号绩效'),
      绩效报告导出: t('department.导出绩效报告'),
      '快捷回复-个人模版': t('department.配置x', {
        x: `${t('nav.phrase')}${t('department.个人模版')}`,
      }),
      '快捷回复-团队模版': t('department.配置x', {
        x: `${t('nav.phrase')}${t('department.团队模版')}`,
      }),
      超时自动回复: t('department.配置x', { x: t('nav.autoReply') }),
      进店欢迎语: t('department.配置x', { x: t('aide.进店欢迎语') }),
      配置接待评分任务: t('aide.配置接待评分任务'),
      重要提醒: t('department.配置x', { x: t('nav.remind') }),
      WA消息模版: t('department.配置x', { x: t('nav.waMsgTemp') }),
      AI智能接待: t('department.配置x', { x: t('aide.AI智能接待') }),
      配置催单催付任务: t('department.配置催单催付任务'),
      配置缺货提醒任务: t('department.配置缺货提醒任务'),
      配置物流呵护任务: t('department.配置物流呵护任务'),
      配置弃单挽回任务: t('department.配置弃单挽回任务'),
      配置评价管理任务: t('department.配置评价管理任务'),
      帐号管理: t('员工管理'),
      店铺管理: t('nav.platform'),
      买家管理: t('department.买家管理'),
      访问待办管理中心: t('todo.访问待办管理中心'),
      查看待办数据: t('todo.查看待办数据'),
      导出待办数据: t('todo.导出待办数据'),
      标记商品缺货: t('outofstock_perm_mark'),
      配置暂停自动回复: t('department.配置x', { x: t('pause_auto_reply') }),
      敏感词: t('敏感词'),
      商品组: t('商品管理'),
      创建补发单: t('创建补发单'),
      审核补发单: t('审核补发单'),
      查看AI问答数据: t('查看AI问答数据'),
      导出AI问答数据: t('导出AI问答数据'),
      查看平台数据: t('查看平台数据'),
      导出平台数据: t('导出平台数据'),
      商品知识: t('商品知识'),
      提交AI无法回复问题: t('提交AI无法回复问题'),
      提交AI回复错误问题: t('提交AI回复错误问题'),
      查看活动数据: t('查看活动数据'),
      导出活动数据: t('导出活动数据'),
      配置智能CSAT邀评: t('department.配置x', { x: t('智能CSAT邀评') }),
    };

    return permissionNameLabel;
  }, [t]);
}

export function usePermissionGroupNameLabel() {
  const { t } = useTranslate();

  return useMemo(() => {
    return {
      消息: t('department.客服基础接待（消息）'),
      数据中心: t('department.数据（数据中心）'),
      跟单助手: t('department.自动化任务配置（跟单助手）'),
      配置中心: t('department.管理（管理中心）'),
      第三方权限: t('第三方权限'),
      AI运营: t('AI运营'),
    };
  }, [t]);
}

export function usePermissionDescriptionLabel() {
  const { t } = useTranslate();

  return useMemo<Partial<Record<General.PermissionName, string>>>(() => {
    return {
      订单敏感信息: t('department.授权后，帐号可查看订单中的买家信息与订单实际收入'),
    };
  }, [t]);
}
